// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__RbzFi","file":"styles_file__3Penq"};